import { ref } from 'vue'

export function useViewport() {
  const viewport = ref('desktop')

  const viewportOptions = [
    { value: 'mobile', label: __('Mobile') },
    { value: 'tablet', label: __('Tablet') },
    { value: 'desktop', label: __('Desktop') },
  ]

  return {
    viewport,
    viewportOptions,
    setViewport(newViewport) {
      viewport.value = newViewport
    },
    isMobile() {
      return viewport.value === 'mobile'
    },
    isTablet() {
      return viewport.value === 'tablet'
    },
    isDesktop() {
      return viewport.value === 'desktop'
    },
  }
}
